import { Permission, PermissionEntitiesNames } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/pipeline-monitoring')({
  beforeLoad: ({ context, preload }) => {
    const { hasAllowedPermissionToResource } = context.userPermissions;
    context.validatePermissions({
      isAllowed:
        hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.SOURCE, permission: Permission.READ }) &&
        hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.MODEL, permission: Permission.READ }),
      preload,
    });
  },
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
